<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="inspectionInComings">
      <div slot="toolbar">
        <el-button
            slot="toolbar"
            type="primary"
            size="mini"
            @click="$refs.editInspectionIncoming.open(0)">
          新建
        </el-button>
        <el-button :loading="exportLoading1" type="primary" @click="exportExcel()">
          导出
        </el-button>
        <el-input
            ref="searchInput"
            v-model.trim="filter.filter"
            class="search-bar"
            clearable
            style="width: 260px;float: right;"
            placeholder="请输入"
            @keyup.enter.native="handleSearch">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>
        </el-input>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="检验结果">
            <el-select v-model.trim="filter.inspectionResult" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.inspectionResult)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="送货单号">
            <el-input v-model.trim="filter.deliveryNo" clearable/>
          </vm-search>
          <vm-search label="检验状态">
            <el-select v-model.trim="filter.checkStatus" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.checkStatus)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="凭证号">
            <el-input v-model.trim="filter.voucherNo" clearable/>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
          <vm-search label="检验员">
            <el-input v-model.trim="filter.inspectorName" clearable/>
          </vm-search>
          <vm-search label="报告编号">
            <el-input v-model.trim="filter.billNo" clearable/>
          </vm-search>
          <vm-search label="检验单号">
            <el-input v-model.trim="filter.inspectionReportNo" clearable/>
          </vm-search>
          <vm-search label="供应商">
            <el-input v-model.trim="filter.supplierName" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
              :data="props.row.inspectionReportVOS"
              style="width: 100%">
            <!--            <el-table-column prop="rowIndex" align="center" label="行号" width="55"/>-->
            <el-table-column prop="no" width="110" align="center" label="系统编号"/>
            <el-table-column prop="materialNo" width="110" align="center" label="物料编号"/>
            <el-table-column prop="purchaseOrderNo" width="130" align="center" label="采购单号"/>
            <el-table-column prop="purchaseOrderRowNo" width="130" align="center" label="行号"/>
            <el-table-column prop="materialName" width="300" align="center" label="物料名称"/>
            <el-table-column prop="submissionNum" align="center" label="送检数量"/>
            <el-table-column prop="spotCheckNum" align="center" label="抽检数量"/>
            <el-table-column prop="unqualifiedNum" width="100" align="center" label="抽检不合格数量"/>
            <el-table-column prop="inspectionResult" align="center" width="100" label="检查结果">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.inspectionResult"
                    disabled
                    style="display: block"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="ok"
                    inactive-text="ng"/>
              </template>
            </el-table-column>
            <el-table-column prop="note" width="200px" align="center" label="备注">
              <template slot-scope="scope">
                <el-input v-model="scope.row.note" type="textarea"/>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" width="110" align="center" label="报告编号"/>
      <el-table-column prop="voucherNo" align="center" label="凭证号"/>
      <el-table-column prop="supplierName" align="center" label="供应商"/>
      <el-table-column prop="deliveryNo" align="center" label="送货单号"/>
      <el-table-column prop="deliveryDate" align="center" width="180px" label="送货日期"/>
      <el-table-column align="center" width="100" label="检验状态">
        <template slot-scope="scope">
          <el-tag size="mini" :type="checkStatusTagType(scope.row.checkStatus)">
            {{ constant.checkStatus[scope.row.checkStatus] || "-" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" width="100" label="检验结果">
        <template slot-scope="scope">
          <el-tag size="mini" :type="inspectionResultTagType(scope.row)">
            {{ inspectionResultText(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" width="180px" label="报告创建时间"/>
      <el-table-column prop="preliminaryInvestigation" align="center" label="问题描述"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <preview ref="preview" @save-success="getList(-1)"/>
    <inspection-incoming-edit ref="editInspectionIncoming" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "../../../util/constant";
  import constants from "@/util/constants";
  import Preview from "@/views/purchase/inspectionReport/Preview";
  import InspectionReportEdit from "@/views/purchase/inspectionReport/InspectionReportEdit";
  import InspectionIncomingEdit from "@/views/purchase/inspectionIncoming/InspectionIncomingEdit";

  export default {
    components: {InspectionIncomingEdit, Preview, VmTable, VmSearch},
    data() {
      return {
        constant,
        constants,
        reportStatus: constant.toSelect(constant.reportStatus, "addAll"),
        show: "",
        exportLoading: false,
        exportLoading1: false,
        submitLoading: false,
        filter: {
          filter: "",
          voucherNo: "",
          //默认待检验；清空后表示不过滤，查询全部
          checkStatus: 0,
          deliveryNo: "",
          materialNo: "",
          factoryNo: "",
          inspectorName: "",
          inspectionReportNo: "",
          billNo: "",
          supplierName: "",
          //默认只查 NG；清空后表示不过滤，查询全部
          inspectionResult: 0,
          //默认不过滤时间；清空状态同理
          beginCreateTime: "",
          endCreateTime: "",
        },
        details: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSearch() {
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      checkStatusTagType(status) {
        return {0: "info", 1: "success", 2: "primary"}[status] || "info";
      },
      //整单结果：任一报告不合格即 NG
      inspectionResultText(row) {
        const reports = row.inspectionReportVOS || [];
        if (reports.length === 0) {
          return "-";
        }
        return reports.some(r => !r.inspectionResult) ? "NG" : "OK";
      },
      inspectionResultTagType(row) {
        const text = this.inspectionResultText(row);
        if (text === "NG") {
          return "danger";
        }
        if (text === "OK") {
          return "success";
        }
        return "info";
      },
      //去掉空值参数，避免后端把空字符串解析成 null 参与过滤
      buildExportParams() {
        const params = {};
        Object.keys(this.filter).forEach(key => {
          const value = this.filter[key];
          if (value !== undefined && value !== null && value !== "") {
            params[key] = value;
          }
        });
        return params;
      },
      exportExcel() {
        const params = this.buildExportParams();
        //时间、检验状态、检验结果都没有作为收窄条件时会命中全表（180万行），
        //必然超时导致导出为空，这里才兜底到近一个月；已有收窄条件时与列表口径保持一致
        if (!params.beginCreateTime && !params.endCreateTime
            && params.checkStatus == null && params.inspectionResult == null) {
          params.beginCreateTime = this.$moment().subtract(1, "month").format("YYYY-MM-DD");
          params.endCreateTime = this.$moment().format("YYYY-MM-DD");
          this.$message.info("未选择创建时间，默认导出近一个月的数据");
        }
        this.exportLoading1 = true;
        this.$http
          .exportFile("basic", "inspectionInComings/exportInspection", params)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = res.headers.filename ? decodeURI(res.headers.filename) : "来料报告.xlsx";
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              let url = URL.createObjectURL(blob);
              a.href = url;
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              //延迟释放：同步 revoke 会中断尚未完成的下载，导致文件为空
              setTimeout(() => URL.revokeObjectURL(url), 2000);
            }
            this.exportLoading1 = false;
          })
          .catch(() => {
            this.exportLoading1 = false;
          });
      },
      edit(row) {
        this.$refs.editInspectionIncoming.open(row.pkid);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
